import { isNull } from "lodash";
const isInSameWeek = (dayA, dayB) => {
  if (isNull(dayB)) {
    return false;
  }
  return dayA.isSame(dayB, "week");
};
const isInSameMonth = (dayA, dayB) => {
  if (isNull(dayB)) {
    return false;
  }
  return dayA.isSame(dayB, "month");
};
export {
  isInSameMonth,
  isInSameWeek
};
